export default __webpack_public_path__ + "static/oferte-e221d88859c25cf3b7d54647d8e2ffb4.jpg";